const TranslatorActionTypes = {
  SET_SEARCH_RESULT: "SET_SEARCH_RESULT",
  CLEAR_RESULTS: "CLEAR_RESULTS",
};

export default TranslatorActionTypes;
